import SectionHeading from "@/components/base/SectionHeading";
import MangaCard from "@/components/feature/MangaCard";
import { mangaSeries } from "@/mocks/manga";

export default function TodayUpdates() {
  const today = mangaSeries.filter((m) => m.isToday || m.isNew || m.isBackfill);
  const hot = [...mangaSeries].sort((a, b) => b.rating - a.rating).slice(0, 4);

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="实时动态"
        title="今日更新抢先看"
        desc="66漫画网今天更新内容实时呈现，最新话、补更动态一次看齐，追更不再错过。"
        moreTo="/updates"
        moreText="全部更新"
      />
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-5">
        {today.map((m) => (
          <MangaCard key={m.id} manga={m} />
        ))}
      </div>

      <div className="mt-16">
        <SectionHeading
          eyebrow="人气推荐"
          title="热门追更榜"
          desc="读者评分最高的连载漫画，追更进度一目了然。"
          moreTo="/series"
          moreText="更多作品"
        />
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-5 lg:grid-cols-4">
          {hot.map((m) => (
            <MangaCard key={m.id} manga={m} />
          ))}
        </div>
      </div>
    </section>
  );
}